import LiberarPagamentoLista from './componentes/LiberarPagamentoLista.vue';

export default {
  path: '/liberar-pagamento',
  component: LiberarPagamentoLista,
  meta: { auth: true },
  name: 'liberar-pagamento',
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/liberar-pagamento/rotas.js